var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"zoom-image-viewer scroll-hidden"},[_c('canvas',{staticStyle:{"position":"absolute","margin":"0","padding":"0"},attrs:{"id":"zoom-canvas"}})])
}]

export { render, staticRenderFns }